import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';

import {
  StateService,
  RouterService,
  ToolService,
  ConstructionDayReportType,
} from 'projects/shared/src/public-api';

@Component({
  selector: 'lib-viewer-dialog',
  templateUrl: './viewer-dialog.component.html',
  styleUrls: ['./viewer-dialog.component.scss'],
  standalone: false,
})
export class ViewerDialogComponent implements OnInit {
  fileExtension: string;
  docId: string;
  pdfType: string;
  name: string;
  docLoaded: boolean;
  constructor(
    private route: ActivatedRoute,
    public state: StateService,
    private modalController: ModalController,
    public routerService: RouterService,
    public tools: ToolService
  ) {}

  ngOnInit() {
    if (this.pdfType === 'document') {
      let nodeItem = this.state.loadNodeItem(this.docId);
      this.name = nodeItem.displayName;
      this.fileExtension = nodeItem.fileExtension;
      this.docId = nodeItem.id;
      this.docLoaded = true;
    } else if (this.pdfType === 'construction-day-report') {
      this.state.loadConSiteReportById(this.docId).subscribe((x) => {
        let typeLabel = '';
        switch (x.type) {
          case ConstructionDayReportType.$0:
            typeLabel = 'Bautagesbericht';
            break;
          case ConstructionDayReportType.$1:
            typeLabel = 'Fahrtenbericht';
            break;
          case ConstructionDayReportType.$2:
            typeLabel = 'Arbeitszeitbericht';
            break;
        }

        this.name =
          typeLabel +
          ' ' +
          this.state.getConstructionSiteName(x.constructionSite) +
          ' vom ' +
          this.tools.formatDt(x.date);
        this.fileExtension = '.pdf';
        this.docId = x.id;
        this.docLoaded = true;
      });
    } else if (this.pdfType === 'hour-overview') {
      this.name =
        'Monatsübersicht Arbeitszeiten Stand ' +
        this.tools.formatDt(new Date().toISOString());
      this.fileExtension = '.pdf';
      this.docId = this.docId;
      this.docLoaded = true;
    } else if (this.pdfType === 'inspection') {
      this.name = 'DGUV-Bericht';
      this.fileExtension = '.pdf';
      this.docId = this.docId;
      this.docLoaded = true;
    }
  }

  cancel() {
    return this.modalController.dismiss(null, 'cancel');
  }
}
